var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 450,
    height: 300,
    fill: "#009543"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 450,
    height: 210,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 450,
    height: 90,
    fill: "#00209f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    d: "m224.76,95.569c-1.7098,0.03684-3.3781,1.9308-3.3781,1.9308l0.14732,20.233-6.3878,6.692h5.1711l-0.0437,11.603-30.591,41.193-4.5222-1.563-7.9041,16.861s19.55,12.242,47.925,11.907c31.144-0.37035,48.064-12.471,48.064-12.471l-8.1677-16.644-3.9996,1.7393-30.983-40.979-0.0437-11.949h5.1711l-7.0378-6.6088,0.0416-20.159s-1.7514-1.8203-3.4613-1.7835z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 5,
    d: "m235.43,144.01-21.153,0s-7.6776-16.176-6.4331-27.485c1.2672-11.515,7.8483-16.963,16.598-17.059,10.345-0.11526,15.767,5.0691,17.405,16.598,1.6231,11.424-6.4172,27.947-6.4172,27.947z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.79,182.57c-0.3458,0.46106-2.8816,5.5326-2.8816,5.5326l4.38-0.92211-1.4984-4.6105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.32,189.14-4.6105,1.4984,5.5327,2.19-0.92212-3.6884z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.4,182.68,2.3053,6.8006,5.6479-1.6137-1.4984-3.2274-6.4548-1.9595z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.97,191.91,0.80685,2.7663,7.4921,1.8442-2.9968-6.3395-5.3021,1.729z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.27,186.14,2.6511,6.3395,5.6479-2.19-1.8442-2.7663-6.4548-1.3832z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.96,194.79,0.92211,2.4205,8.76,1.2679-3.6884-5.7632-5.9937,2.0747z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.37,187.99,3.2274,5.6479,8.1837-2.9969-0.9221-2.19-10.489-0.46106z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.1,195.71,1.729,2.9969,10.143-0.3458-3.8037-5.6479-8.0684,2.9968z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.82,188.22,2.7663,4.7258,6.4548-3.1121-1.729-2.5358-7.4921,0.92212z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.42,191.79-6.4548,3.2274,1.729,2.7663,8.6448-1.3832-3.919-4.6106z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.5,186.83,3.3426,4.1495,5.4174-4.2648-1.8442-1.9595-6.9158,2.0748z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.41,189.02-5.1869,3.919,1.3832,2.4205,7.1464-1.8442-3.3426-4.4953z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.56,180.84,1.2679,1.8442-3.5732,5.3021-3.6884-4.7258,5.9937-2.4205z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.98,185.45,2.19,4.38-4.38,1.4984-0.34579-2.0748,2.5358-3.8037z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLs);
export default __webpack_public_path__ + "static/media/ls.636e15aeb3bfb120ac2a980fc7250770.svg";
export { ForwardRef as ReactComponent };